import React, { Component } from 'react';
import { Grid, withStyles } from '@material-ui/core';
import Topbar from '../common/Topbar';
import Footer from '../common/Footer';
import TitleText from '../common/TitleText';

const styles = (theme) => ({
  bg: {
    width: '100%',
    // height: 'calc(100vh - 85px)',
    overflowX: 'hidden',
    overflowY: 'auto',
    backgroundColor: '#fafafa',
  },
  imgWeb: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  imgMobile: {
    width: '100%',
    WebkitTouchCallout: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
});

class Philosophy extends Component {
  constructor(props) {
    super(props);
    this.state = { matches: window.matchMedia('(max-width:600px)').matches };
  }
  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Topbar />
        <div className={classes.bg}>
          <Grid id="positioning_grid" container justify="center" style={{ padding: '0 30px' }}>
            <Grid
              id="index_grid"
              container
              justify="flex-start"
              style={{ padding: '2vh calc(2vw - 30px)', color: '#1b1d54', fontSize: '1.3em' }}
            >
              <b>회사소개 〉 경영철학</b>
            </Grid>
            <Grid
              container
              justify="center"
              item
              xs={12}
              md={6}
              style={{ backgroundColor: '#ffffff', margin: '4vh 0', borderRadius: '20px' }}
            >
              <TitleText title="경영철학" />

              <div style={{ paddingTop: '2vh', textAlign: 'center', lineHeight: '1.8em' }}>
                <div style={{ color: '#403e6e', fontWeight: 'bold', fontSize: '1.2em' }}> "머리엔 창조정신"</div>
                <div style={{ color: '#403e6e', fontWeight: 'bold', fontSize: '1.2em' }}> "몸과 마음은 세계를"</div>
                <span style={{ color: '#403e6e', fontWeight: 'bold', fontSize: '1.2em' }}> "행동은 야무진 일처리"...</span>
                <br />
                라는 사훈과
                <br />
                <br />
                <img alt="경영철학" src="./images/quotes_img.png" />
                <br />
                <span
                  style={{
                    color: '#555555',
                    fontSize: this.state.matches ? '1.5rem' : '2rem',
                    lineHeight: '1.5em',
                  }}
                >
                  혼을 담은
                  <span style={{ color: '#403e6e', fontWeight: 'bold' }}> 노력은</span>
                  <br />
                  절대 <span style={{ color: '#403e6e', fontWeight: 'bold' }}>배신하지 않는다.</span>
                </span>
                <br />
                는 신념을 바탕으로
                <br />
                <br /> 전 임직원이 참된 인성으로 화합하고
                <br />
                창의적인 기획력, 지속적인 연구개발로
                <br /> 매사에 장인정신을 발휘하여
                <br /> 어떠한 시련과 역경 속에서도 굴하지 않는 <br />
                <b>참 "두원인"들과 항상 함께하며</b>
                <br />
                <b>행복한 일터로 성장하고자 합니다.</b>
              </div>
              {/* <Grid
                container
                justify="center"
                item
                xs={10}
                md={5}
                style={{
                  paddingTop: '3vh',
                  color: '#555555',
                  textAlign: 'center',
                  wordBreak: 'keep-all',
                  fontSize: this.state.matches ? '0.8rem' : '0.9rem',
                  lineHeight: '1.8em',
                }}
              >
                전직원의 화합과 창의적인 노력으로 최고의 제품과 서비스를 제공함으로써 국민의 건강한 문화와 관광활성화에 공헌한다.
              </Grid> */}
              <Grid container justify="center" style={{ paddingTop: '5vh', marginBottom: '5vh' }}>
                <Grid item xs={10} md={5}>
                  <img alt="이미지" src="./images/philo_img_new.jpg" className={classes.imgWeb} onContextMenu={(e) => e.preventDefault()} />
                  <img
                    alt="이미지"
                    src="./images/philo_img_new.jpg"
                    className={classes.imgMobile}
                    onContextMenu={(e) => e.preventDefault()}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Footer />
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(Philosophy);
